import { FC } from "react";

import { DashboardTypography } from "@/dashboard-design-system/Typography";

type ShareFormTabTitleProps = {
  children: React.ReactNode;
};

export const ShareFormTabTitle: FC<ShareFormTabTitleProps> = ({ children }) => {
  return (
    <DashboardTypography variant="h5" vibe="text-reverse-intense" textAlign="center">
      {children}
    </DashboardTypography>
  );
};
